module.exports = __webpack_public_path__ + "img/jinjiang.5d2dc84d.png";